import { takeLatest, call, put } from "redux-saga/effects";
import { PARTNERS_PAGE_LOAD, partnersLoaded } from "../../actions/partners";
import listPartners from "sc/backend/oncall/administration/partners/list";
import { showErrorPage } from "sc/actions/ui/location";

const partnersPageLoadSaga = function*(action) {
  try {
    const result = yield call(listPartners);
    yield put(partnersLoaded(result.partners));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(PARTNERS_PAGE_LOAD, partnersPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/partners/list-page-load.js